var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarehouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M10.4 22.8c-.3 0-.6-.1-.9-.2L3.4 19c-.3-.2-.5-.5-.5-.8v-5.4c0-.6.3-1.2.9-1.5l10-5.8c.2-.1.5-.1.7.2.1.2.1.5-.2.7l-10 5.8c-.2.1-.4.4-.4.6v5.4l1 .6 5.1 3c.2.1.5.1.7 0l4.9-2.9c.2-.1.5-.1.7.2.1.2.1.5-.2.7l-4.9 2.9c-.2 0-.5.1-.8.1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M10.4 22.8c-.3 0-.6-.1-.9-.2l-3.6-2.1c-.2-.1-.3-.4-.2-.7s.4-.3.7-.2l3.6 2.1c.2.1.5.1.7 0l4.9-2.9c.2-.1.5-.1.7.2.1.2.1.5-.2.7l-4.9 2.9c-.2.1-.5.2-.8.2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M10.4 22.6c-.3 0-.5-.2-.5-.5v-6c0-.3.2-.5.5-.5s.5.2.5.5v6c0 .3-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "m11 19.1-3.1-8.5L2.1 13c-.3.1-.9.3-1.1-.2s.3-.9.9-1.3l12.5-6.4 3.7-1.8c.5-.3 1.2 0 1.5.5l3.6 6.4c.1.2.1.5-.2.7-.2.1-.5.1-.7-.2l-3.6-6.4c0-.1-.1-.1-.1-.1L14.8 6 8.5 9.3l3.1 8.4 2.1-1.2c.2-.1.5 0 .7.2.1.2 0 .5-.2.7z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M13.4 21.2c-.3 0-.5-.2-.5-.5v-3.4c0-.3.2-.5.5-.5s.5.2.5.5v3.4c0 .2-.2.5-.5.5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M19 20.6c-3.4 0-6.1-2.7-6.1-6.1s2.7-6.1 6.1-6.1 6.1 2.7 6.1 6.1-2.8 6.1-6.1 6.1m0-11.1c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M10.3 20.3c-.1 0-.2 0-.2-.1l-6.8-3.8c-.2-.1-.3-.4-.2-.7.1-.2.4-.3.7-.2l6.8 3.8c.2.1.3.4.2.7-.1.2-.3.3-.5.3M10.3 17.8c-.1 0-.2 0-.2-.1l-6.8-3.8c-.2-.1-.3-.4-.2-.7.1-.2.4-.3.7-.2l6.8 3.8c.2.1.3.4.2.7-.1.2-.3.3-.5.3"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M21.2 14.1h-1v-1.8h-1.9v1.8h-1v-2.8h3.9z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M19.1 17h-1v-1.8h-1.9V17h-1v-2.8h3.9z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDE0E8",
  d: "M23.2 17h-1v-1.8h-1.9V17h-1v-2.8h3.9z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#A8C4CC",
  d: "M23.8 17.8h-9.7c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h9.7c.3 0 .5.2.5.5s-.2.5-.5.5"
})));
export default SvgWarehouse;